// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_dw-3";
export var flatBottomCorners = "_dw-5";
export var productImage = "_dw-0";
export var quantityContainer = "_dw-2";
export var quantityHeader = "_dw-6";
export var tooltip = "_dw-1";
export var wrapAndEllipsesOverflow = "_dw-4";